<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="480"
      persistent
      scrollable
    >
      <v-card color="brand-card-bg">
        <v-toolbar
          color="brand-card-bg"
          flat
          height="80"
          max-height="80"
        >
          <v-toolbar-title class="pl-3">
            <div class="brand-text-title">
              {{ toLocaleUpperCase($t('Store.SelectStoreDialog.Title')) }}
            </div>
            <div class="brand-text-small">
              {{ $t('Store.SelectStoreDialog.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            class="ma-0"
            color="brand-green-dark"
            icon
            outlined
            style="background-color: white"
            @click="onCancelButtonClick"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="mx-6 brand-green-dark" />

        <v-card-text class="pa-2">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <v-list
                  class="pa-0"
                  color="transparent"
                >
                  <template v-for="(store, idx) in stores">
                    <v-list-item
                      v-if="!storeIsHidden(store)"
                      :key="`list-item-${idx}`"
                      :disabled="storeIsDisabled(store)"
                      class="brand-beige mb-2 px-3"
                      ripple
                      @click="onStoreSelected(store)"
                    >
                      <v-list-item-avatar
                        size="40"
                        style="border: var(--v-brand-green-dark-base) solid 1px;"
                      >
                        <img
                          v-if="store.Category.Image"
                          :src="store.Category.Image"
                          :style="{filter: (storeIsDisabled(store) ? 'grayscale(1)' : 'grayscale(0)')}"
                          style="height: 40px; width: auto;"
                        >
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="text-left">
                          <h3 class="text-body mt-1">
                            {{ store.Category.Name }}
                          </h3>
                        </v-list-item-title>

                        <v-list-item-subtitle v-if="store.Category.Description">
                          <span class="brand-text-small brand-grey--text">
                            {{ store.Category.Description }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-chip
                          v-if="storeIsOpened(store)"
                          class="brand-green-dark--text px-1 px-md-2"
                          color="brand-beige-dark"
                          dark
                          label
                          small
                        >
                          <v-icon
                            class="mr-1"
                            small
                          >
                            mdi-clock
                          </v-icon>
                          <span class="text-body">{{ storeDefaultTime(store, 'XS') }}</span>
                        </v-chip>

                        <v-chip
                          v-else
                          class="brand-text-title brand-green-dark--text px-1 px-md-2"
                          color="brand-beige-dark"
                          dark
                          label
                          small
                        >
                          <span class="text-body">{{ $t('Store.Status.Closed').toLocaleUpperCase($i18n.locale) }}</span>
                        </v-chip>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SelectStoreDialogMixin from '@/theme/default/views/store/SelectStoreDialog.js'

export default {
  name  : 'SelectStoreDialog',
  mixins: [SelectStoreDialogMixin]
}
</script>

<style scoped src="@/theme/default/views/store/SelectStoreDialog.css"></style>
<style scoped>
</style>
